import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Typography, withStyles} from '@material-ui/core'
import MainPaper from '../../../../component/MainPaper'
import PaymentForm from '../../components/PaymentForm'
import PaymentSummary from '../../../../shared/components/PaymentSummary'
import PaymentButtons from '../../../../shared/components/PaymentButtons'
import style from './style'
import Main from "../../../../container/Main";
import {doPaymentRequest, getPaymentRequestJson} from "../../../../helpers";
import {bindActionCreators} from "redux";
import {GenericPaymentActions} from "../../../../shared/actions"
import PaymentMethodList from '../../../../component/PaymentMethodList'
import size from 'lodash/size'
import { DEBIT_CARD_IDS } from '../../../../shared/constants'

class Payment extends Component {

    handleSubmit = (e) => {
        e.preventDefault()
        const data = getPaymentRequestJson(
            this.props.formData,
            this.props.formInputData
        )
        doPaymentRequest(data, this.props, 'feedback')
    }


    shouldComponentUpdate = (nextProps) => {
        return nextProps.hasErrors !== this.props.hasErrors
    }

    render() {
        const {
            classes,
            paymentData,
            formData,
            hasErrors,
            onSubmit,
            queryString
        } = this.props

        const paymentMethods = (paymentData.installments == 1) ? 
            paymentData.paymentMethod :
            paymentData.paymentMethod.filter(paymentMethod => !DEBIT_CARD_IDS.includes(paymentMethod) )
        return (
            <form
                id="payment-form"
                method="POST"
                action="/payments"
                onSubmit={this.handleSubmit}
            >
                <MainPaper
                    after={<PaymentButtons
                        hasErrors={hasErrors}
                        onSubmit={onSubmit}
                        cancelUrl={formData.cancelUrl}
                    />}
                    footer={<PaymentSummary
                        amount={paymentData.amount}
                        currency={paymentData.currency}
                        installments={paymentData.installments}
                        first_installment_expiration_date={paymentData.first_installment_expiration_date}
                    />}
                >
                    <div style={{display: 'flex'}}>
                        <Typography variant="subtitle1" className={classes.subtitle}>Datos de la tarjeta</Typography>
                        { size(paymentMethods) > 1 && <PaymentMethodList paymentMethods={paymentMethods}/> }
                    </div>
                    <PaymentForm
                        cardBin={paymentData.cardBin}
                        paymentMethod={paymentMethods}
                        binRanges={paymentData.binRanges}
                    />
                </MainPaper>
            </form>

        )  //TODO Sacar los input hidden cuando el /payments se pueda llamar con un fetch
    }
}

function mapStateToProps(state) {
    return {
      formData: state.forms.formData,
      paymentData: state.forms.paymentData,
      hasErrors: state.forms.hasErrors,
      formInputData: state.formInputData
    }
}


function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators({...GenericPaymentActions}, dispatch)}
}

const StyledPayment = withStyles(style)(Payment)
const DataBound = connect(mapStateToProps, mapDispatchToProps)(StyledPayment)

export default Main(DataBound)
